/**
 * The full hop collection, assembled from the per-region files.
 *
 * `substitutes` may point at any hop in any of these files; the test suite
 * enforces that every reference resolves.
 */

import type { Hop } from '../../schema/hop';
import { europeHops } from './europe';
import { southernHemisphereHops } from './southern-hemisphere';
import { unitedStatesHops } from './united-states';

export { europeHops } from './europe';
export { southernHemisphereHops } from './southern-hemisphere';
export { unitedStatesHops } from './united-states';

/** Every hop in the catalog. */
export const hops: readonly Hop[] = [...unitedStatesHops, ...europeHops, ...southernHemisphereHops];
